import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SelectControl from 'Components/UI/SelectControl';
import PropTypes from 'prop-types';
import React from 'react';
import { fade } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '0px',
    minWidth: '150px',
    width: '100%',
    '& .MuiFilledInput-root': {
      background: 'transparent',
    },
    '& .MuiInputBase-input': {
      alignContent: 'center',
    },
    '& .MuiSelect-root': {
      fontWeight: theme.typography.fontWeightMedium,
      background: theme.palette.facet.accentBlue20,
      borderRadius: '16px',
      marginBottom: '0px',
      height: '34px',
    },
    '& .MuiInputLabel-filled': {
      transform: 'translate(20px, 25px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      color: theme.palette.common.black,
      transform: 'translate(12px, 15px) scale(0.75)',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.facet.primaryBlue,
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: fade(theme.palette.error.main, 0.8),
    },
    '& .MuiInputBase-root.Mui-error': {
      '& .MuiSelect-root': {
        color: fade(theme.palette.error.main, 0.8),
        backgroundColor: fade(theme.palette.error.main, 0.3),
        '&:hover': {
          backgroundColor: fade(theme.palette.error.main, 0.3),
        },
      },
      '& .MuiInputBase-input': {
        color: fade(theme.palette.error.main, 0.8),
      },
      '& .MuiSvgIcon-root': {
        color: fade(theme.palette.error.main, 0.8),
      },
    },
    paddingBottom: theme.spacing(0),
  },

}));


function LabellessSelectField({
  SelectProps, ...rest
}) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <SelectControl
      classes={{
        root: classes.root,
      }}
      variant={'filled'}
      SelectProps={{
        ...SelectProps,
        disableUnderline: true,
        label: null,
      }}
      showHelperText={false}
      hideLabel
      {...rest}
    />
  );
}

LabellessSelectField.propTypes = {
  SelectProps: {},
};

LabellessSelectField.defaultProps = {
  SelectProps: PropTypes.object,
};

export default LabellessSelectField;
